import React from "react";
import PropTypes from "prop-types";

import { Tooltip, TableRow, TableCell, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import { EditableMetaField } from "components/CaseManagement/CaseDetail/MetaDataTable/EditableMetaField";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";

import { styled } from "@mui/material/styles";

export function MetaTableContent({
  attributes,
  onAttributeChanged,
  onAttributeDeleted
}) {
  const {
    loading: metaTypesLoading,
    error: metaTypesError,
    response: metaTypes
  } = useFetchGetV2("case_meta_types_expanded");

  const handleAttributeValueChanged = (attribute, data_type) => {
    const valueIsString = typeof attribute.value === "string";
    const attributeValue = valueIsString
      ? attribute.value.trim()
      : attribute.value;

    onAttributeChanged(
      {
        ...attribute,
        value: attributeValue
      },
      data_type
    );
  };

  const rowProps = { tabIndex: -1, hover: true };

  return (
    <>
      {attributes.map(attribute => {
        const metaType = metaTypes?.results?.find(
          ({ id }) => id === attribute.type_id
        );

        return (
          <TableRow
            {...rowProps}
            key={`meta-data-table-row-${attribute.type_name}`}
          >
            <TableCellWithWidth data-col={1} width="40">
              <div>
                {attribute.type_name ?? (
                  <Tooltip title="There was a problem retrieving the key's name">
                    <span>------</span>
                  </Tooltip>
                )}
              </div>
              <AttributeDataType>{metaType?.data_type?.name}</AttributeDataType>
            </TableCellWithWidth>
            <TableCellWithWidth data-col={2} width="50">
              <EditableMetaField
                attribute={attribute}
                metaType={metaType}
                onAttributeValueChanged={attribute =>
                  handleAttributeValueChanged(attribute, metaType?.data_type)
                }
              />
            </TableCellWithWidth>
            <TableCellWithWidth data-col={3} width="10" align="right">
              <IconButton
                onClick={() => onAttributeDeleted(attribute?.name)}
                size="large"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </TableCellWithWidth>
          </TableRow>
        );
      })}
      {!metaTypesLoading && metaTypesError && (
        <span>Failed to load attribute types</span>
      )}
    </>
  );
}

const TableCellWithWidth = styled(TableCell)`
  width: ${({ width }) => `${width}%`};
`;

const AttributeDataType = styled("div")`
  font-size: 13px;
  opacity: 0.5;
`;

MetaTableContent.propTypes = {
  attributes: PropTypes.array,
  onAttributeChanged: PropTypes.func.isRequired,
  onAttributeDeleted: PropTypes.func.isRequired
};
